"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfDocumentAuditUploadedByDto = instanceOfDocumentAuditUploadedByDto;
exports.DocumentAuditUploadedByDtoFromJSON = DocumentAuditUploadedByDtoFromJSON;
exports.DocumentAuditUploadedByDtoFromJSONTyped = DocumentAuditUploadedByDtoFromJSONTyped;
exports.DocumentAuditUploadedByDtoToJSON = DocumentAuditUploadedByDtoToJSON;
exports.DocumentAuditUploadedByDtoToJSONTyped = DocumentAuditUploadedByDtoToJSONTyped;
/**
 * Check if a given object implements the DocumentAuditUploadedByDto interface.
 */
function instanceOfDocumentAuditUploadedByDto(value) {
    if (!('profileId' in value) || value['profileId'] === undefined)
        return false;
    if (!('firstName' in value) || value['firstName'] === undefined)
        return false;
    if (!('lastName' in value) || value['lastName'] === undefined)
        return false;
    if (!('email' in value) || value['email'] === undefined)
        return false;
    return true;
}
function DocumentAuditUploadedByDtoFromJSON(json) {
    return DocumentAuditUploadedByDtoFromJSONTyped(json, false);
}
function DocumentAuditUploadedByDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'profileId': json['profileId'],
        'firstName': json['firstName'],
        'lastName': json['lastName'],
        'email': json['email'],
    };
}
function DocumentAuditUploadedByDtoToJSON(json) {
    return DocumentAuditUploadedByDtoToJSONTyped(json, false);
}
function DocumentAuditUploadedByDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'profileId': value['profileId'],
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'email': value['email'],
    };
}
//# sourceMappingURL=DocumentAuditUploadedByDto.js.map